import { Connection } from 'utils';
import { FORGOT_PASSWORD, SIGNIN_TWO_FACTOR_AUTH } from 'constants/api';

const login = {
  forgotPassword: data => Connection.post(FORGOT_PASSWORD, data),
  signInTwoFactorAuth: data => Connection.post(SIGNIN_TWO_FACTOR_AUTH, data),
};

export default login;
